import { AssessmentOverviewFormField } from '../sections/assessment-overview/formField'
import { PatientOverviewFormField } from '../sections/patient-overview/formField'
import { MedicationsFormField } from '../sections/medications/formField'
import { MedicalBackgroundFormField } from '../sections/medical-background/formField'
import { DischargeSummaryFormField } from '../sections/discharge-summary/formField'
import { FinalStepsFormField } from '../sections/final-steps/formField'

// Amalgamate all discharge assessment section form fields
export const DischargeFormField = {
  ...AssessmentOverviewFormField,
  ...PatientOverviewFormField,
  ...MedicationsFormField,
  ...MedicalBackgroundFormField,
  ...DischargeSummaryFormField,
  ...FinalStepsFormField
} as const

export type DischargeFormField = (typeof DischargeFormField)[keyof typeof DischargeFormField]
